import axios from 'axios';

const API_URL = '/api/tenant/locations'; // Endpoint creado en el backend

/**
 * Obtiene todas las ubicaciones disponibles.
 * @returns {Promise<Array<object>>} - Promesa con un array de objetos { ID, NAME }.
 */
export const fetchLocations = async () => {
    try {
        const response = await axios.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching locations:', error);
        throw error; // Propagar para manejo en el componente
    }
}; 